/** Mantle UnstakeRequestsManager — per-id detail getter.
 *  Address on chain 1: `0x38fdf7B489316E03eD8754aD339cb5c4483FDcf9`.
 *
 *  No user-keyed on-chain storage; enumeration only via the
 *  `UnstakeRequestCreated` event. We instead accept caller-supplied
 *  IDs (captured from the withdraw-tx receipt at request time) and
 *  read the detail per-id. */
export const MantleUnstakeRequestsManagerAbi = [
  {
    name: 'requestByID',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'unstakeRequestID' }],
    outputs: [
      {
        type: 'tuple',
        components: [
          { type: 'uint64', name: 'id' },
          { type: 'address', name: 'requester' },
          { type: 'uint128', name: 'mETHLocked' },
          { type: 'uint128', name: 'ethRequested' },
          { type: 'uint128', name: 'cumulativeETHRequested' },
          { type: 'uint64', name: 'blockNumber' },
        ],
      },
    ],
  },
  {
    name: 'requestInfo',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'unstakeRequestID' }],
    outputs: [
      { type: 'bool', name: 'isFinalized' },
      { type: 'uint256', name: 'claimableAmount' },
    ],
  },
] as const
